import { graphql } from '../../gql';

export default graphql(`
    mutation disableUserTOTP($input: ToggleUserTOTPInput!) {
        disableUserTotp(input: $input) {
            ok
            token
        }
    }
`);
